import type { RoleName } from "@storytell/types";
import type { Role } from "./types";

// Map UI roles to backend role format
export const mapRoleToBackend = (role: Role): RoleName => {
  switch (role) {
    case "Owner":
      return "role.owner";
    case "Collaborator":
      return "role.collaborator";
    case "Reader":
      return "role.reader";
  }
};

// Map backend roles to UI format
export const mapRoleToUI = (role: RoleName): Role => {
  switch (role) {
    case "role.owner":
      return "Owner";
    case "role.collaborator":
      return "Collaborator";
    case "role.reader":
      return "Reader";
    default:
      return "Reader";
  }
};
